export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[550px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20product%20photography%20of%20an%20artistic%20fashion%20collection%20spread%20across%20a%20light%20sandstone%20textured%20surface%2C%20items%20including%20sneakers%20a%20canvas%20backpack%20folded%20denim%20jacket%20leather%20belt%20and%20cap%20arranged%20in%20an%20organic%20flowing%20composition%20from%20left%20to%20right%2C%20warm%20golden%20hour%20sunlight%20washing%20across%20the%20scene%20creating%20long%20dramatic%20shadows%2C%20luxury%20bohemian%20aesthetic%2C%20rich%20earthy%20tones%20with%20touches%20of%20muted%20olive%20and%20rust%2C%20editorial%20catalog%20spread%2C%20high%20detail%20immersive%20composition&width=1800&height=1100&seq=cta-bg-v2&orientation=landscape"
          alt="Get your oopbuy spreadsheet system now"
          title="OOPBuy Spreadsheet order tracking system"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      {/* Content — triangular composition */}
      <div className="relative z-10 w-full h-full px-6 md:px-16">
        {/* Top Left: Title */}
        <div className="absolute top-1/4 left-6 md:left-16">
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-none">
            get your
          </h2>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-none mt-1">
            spreadsheet now
          </h2>
        </div>

        {/* Bottom Left: CTA Button */}
        <div className="absolute bottom-16 md:bottom-20 left-6 md:left-16">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-7 py-3.5 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-white/90 transition-colors cursor-pointer"
          >
            <span>buy it now</span>
            <span className="w-8 h-8 bg-foreground-900 rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </a>
        </div>

        {/* Bottom Right: Description */}
        <div className="absolute bottom-16 md:bottom-20 right-6 md:right-16 text-right">
          <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xs">
            Start tracking orders like a pro.
            <br />
            Join 10,000+ smart sellers.
          </p>
        </div>
      </div>
    </section>
  );
}